<template>
  <div class="youtube">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/EjMuHmPsDco" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
  name: 'Youtube',
};
</script>

<style lang="scss" scoped>
.youtube {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  margin: 20px 0;
  iframe {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}
</style>